import { render, staticRenderFns } from "./TemplateCreation.vue?vue&type=template&id=07cd0e2a"
import script from "./TemplateCreation.vue?vue&type=script&lang=js"
export * from "./TemplateCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports